export function loadFrill() {
  if (window.Frill) return;

  (function (t, r) {
    function s() {
      const a = r.getElementsByTagName("script")[0];
      const e = r.createElement("script");
      e.type = "text/javascript";
      e.async = true;
      e.src = "https://widget.frill.co/v2/container.js";
      a.parentNode.insertBefore(e, a);
    }

    if (!t.Frill) {
      let o = 0, i = {};
      t.Frill = function (e, p) {
        let n, l = o++, c = new Promise(function (v, d) {
          i[l] = {
            params: [e, p],
            resolve: function (f) {
              n = f;
              v(f);
            },
            reject: d
          };
        });

        c.destroy = function () {
          delete i[l];
          n && n.destroy();
        };

        return c;
      };
      t.Frill.q = i;
    }

    r.readyState === "complete" || r.readyState === "interactive"
      ? s()
      : r.addEventListener("DOMContentLoaded", s);
  })(window, document);
}